import { signal } from '@preact/signals';

const initialToken = typeof localStorage !== 'undefined' ? localStorage.getItem('alfred_token') : null;
export const tokenSignal = signal<string | null>(initialToken || null);
export const isAuthenticatedSignal = signal<boolean>(Boolean(tokenSignal.value));

export function setToken(token: string) {
  tokenSignal.value = token;
  isAuthenticatedSignal.value = true;
  if (typeof localStorage !== 'undefined') {
    localStorage.setItem('alfred_token', token);
  }
}

export function logout() {
  tokenSignal.value = null;
  isAuthenticatedSignal.value = false;
  if (typeof localStorage !== 'undefined') {
    localStorage.removeItem('alfred_token');
  }
}
